import React, { PropTypes, Component } from 'react'
import { Link } from 'react-router'
import classes from './Pagination.scss'
import { get } from 'lodash'

class Pagination extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    pageCount: PropTypes.number.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      currentPage: parseInt(get(props, 'location.query.page') || 1, 10)
    }
  }

  componentWillReceiveProps (nextProps) {
    const path = 'location.query.page'
    if (get(this.props, path) !== get(nextProps, path)) {
      this.setState({
        currentPage: parseInt(get(nextProps, 'location.query.page') || 1, 10)
      })
    }
  }

  _onEnter = (e) => {
    if (e.keyCode === 13) {
      this._query()
    }
  }

  _query = () => {
    const { location, router, pageCount } = this.props
    if (this.state.currentPage > pageCount) return
    const { pathname, query: { page, ...rest } } = location // eslint-disable-line
    const queryString = Object.keys(rest)
      .reduce((string, key) => `${string}&${key}=${rest[key]}`, '')
    router.push(`${pathname}?page=${this.state.currentPage}${queryString}`)
  }

  render () {
    const { location, pageCount } = this.props
    const { pathname, query: { page, ...rest } } = location // eslint-disable-line
    const queryString = Object.keys(rest)
      .reduce((string, key) => `${string}&${key}=${rest[key]}`, '')
    const { currentPage } = this.state

    return pageCount ? (
      <div className={classes.pagination}>
        {currentPage > 1 && (
          <Link to={`${pathname}?page=${currentPage - 1}${queryString}`}>
            <img className={classes.arrow} src='/images/icon-arrow-left.png' alt='icon-arrow-left' />
          </Link>
        )}
        <input type='number' pattern='[0-9]*' value={currentPage}
          onKeyDown={this._onEnter}
          onBlur={this._query}
          onChange={e => this.setState({ currentPage: e.target.value })} />
        <span className={classes.pageCount}>/ {pageCount}</span>
        {currentPage < pageCount && (
          <Link to={`${pathname}?page=${currentPage + 1}${queryString}`}>
            <img className={classes.arrow} src='/images/icon-arrow-right.png' alt='icon-arrow-right' />
          </Link>
        )}
      </div>
    ) : null
  }
}

export default Pagination



// WEBPACK FOOTER //
// ./src/components/Pagination.js